module.exports = __webpack_public_path__ + "img/2-7-nyny.039e4d51.jpg";